var _objectWithoutProperties = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _slicedToArray = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var HistoryEvent =
/*#__PURE__*/
function () {
  "use strict";

  function HistoryEvent(props, assets) {
    _classCallCheck(this, HistoryEvent);

    this.asset = props.asset;
    this.receivingAsset = props.receivingAsset;
    this.type = props.type;
    this.value = props.value;
    this.message = props.message || null;
    this.from = props.from;
    this.to = props.to;
    this.tx = props.tx;
    this.timestamp = props.timestamp;
    this.assets = assets;
  }

  _createClass(HistoryEvent, [{
    key: "getAsset",
    value: function getAsset() {
      var _this = this;

      var _this$assets$filter = this.assets.filter(function (_asset) {
        return _asset.id === _this.asset;
      }),
          _this$assets$filter2 = _slicedToArray(_this$assets$filter, 1),
          asset = _this$assets$filter2[0];

      return asset || null;
    }
  }, {
    key: "getReceivingAsset",
    value: function getReceivingAsset() {
      var _this2 = this;

      if (!this.receivingAsset) {
        return null;
      }

      var _this$assets$filter3 = this.assets.filter(function (_asset) {
        return _asset.id === _this2.receivingAsset;
      }),
          _this$assets$filter4 = _slicedToArray(_this$assets$filter3, 1),
          asset = _this$assets$filter4[0];

      return asset || null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var assets = this.assets,
          json = _objectWithoutProperties(this, ["assets"]);

      return json;
    }
  }]);

  return HistoryEvent;
}();

module.exports = HistoryEvent;